export const GET_TUTORIALS = "Tutorials/GET_TUTORIALS";
export const GET_TUTORIALS_SUCCESSFULL = "Tutorials/GET_TUTORIALS_SUCCESSFULL";
export const GET_TUTORIALS_FAILED = "Tutorials/GET_TUTORIALS_FAILED";
